/**
 * The Arche Store's addresses. Every page fits the edge's snapshot rewrite
 * (`/a/<1-3 segments>`); search and sort variants ride the query string, which
 * the snapshots ignore.
 */
export const STORE_HOME_PATH = '/a/store';
export const STORE_APPS_PATH = '/a/store/apps';
export const STORE_TOP_PATH = '/a/store/top';
export const STORE_CATEGORIES_PATH = '/a/store/categories';
export const STORE_SEARCH_PATH = '/a/store/search';
/** The Games tab is the Games page. */
export const STORE_GAMES_PATH = '/a/games';
/** The more functional search: the old Arche Store. */
export const ADVANCED_SEARCH_PATH = '/marketplace/browse';

export function storeAppPagePath(slug: string): string {
  return `/a/store/app/${slug}`;
}

export function storeCategoryPath(id: string, sort?: 'popular' | 'newest' | 'name'): string {
  const base = `/a/store/category/${id}`;
  return sort && sort !== 'popular' ? `${base}?sort=${sort}` : base;
}

export function storeStoryPath(slug: string): string {
  return `/a/store/story/${slug}`;
}

export function storeSearchPath(query?: string): string {
  return query ? `${STORE_SEARCH_PATH}?q=${encodeURIComponent(query)}` : STORE_SEARCH_PATH;
}

export function advancedSearchPath(query?: string): string {
  return query ? `${ADVANCED_SEARCH_PATH}?q=${encodeURIComponent(query)}` : ADVANCED_SEARCH_PATH;
}

/** Which tab of the store a page belongs to. */
export type StoreTab = 'today' | 'apps' | 'games' | 'top' | 'categories' | 'search';
